<!--
 * @description: 首页视频切换
 * @Author: Jay
 * @Date: 2021-09-22 11:54:40
 * @LastEditors: Jay
 * @LastEditTime: 2022-02-14 10:11:58
-->
<template>
  <!-- 视频区域 -->
  <div>
    <video
      id="playVideos"
      :preload="preload"
      :poster="videoImg"
      align="center"
      :controls="controls"
      :autoplay="autoplay"
      style="object-fit: fill"
      class="video-code"
      muted
    >
      <source :src="videoSrc" type="video/mp4" />
    </video>
    <!-- 视频 标题 居中显示 -->
    <div class="center-bot">
      <div class="font_size_xxl text-white text-align">{{ cenTitle }}</div>
      <div class="font_size_xl text-gray text-align margin-top-sm">
        <span class="showCss" @click="popV">
          观看影片 <span class="icon cuIcon-video"></span>
        </span>
      </div>
    </div>
    <!-- 右下角 视频选择 -->
    <div class="right-bot padding-sm flex">
      <div class="" v-for="(item, index) in videoList" :key="index">
        <div
          class="bot-lebo"
          @mouseover="mouseOver(item, index)"
          @mouseleave="mouseLeave"
        >
          <!-- 视频 -->
          <div class="text-align" v-show="ifVideo == true">
            <!--<div class="text-white padding-bottom-xs" v-show="videoId == index"> -->
            <div class="text-white padding-bottom-xs" v-show="videoId == index">
              {{ item.name }}
            </div>
            <video
              :preload="preload"
              :poster="$api + item.image"
              align="center"
              :controls="controls"
              :autoplay="autoplay"
              style="object-fit: fill"
              class="right-video"
              v-show="videoId == index"
              muted
              @click="slectVideo(item, index)"
            >
              <source :src="$api + item.file" type="video/mp4" />
            </video>
          </div>
          <div class="bot-bottom" @click="slectVideo(item, index)">
            <!-- 当前第几条 -->
            <div class="margin-top-sm">
              <div class="margin-sm" v-show="indexId == index">
                <span class="font_size_lg text-red">{{ index + 1 }}</span>
                <span class="font_size_lg text-white">/</span>
                <span class="font_size_df text-white">
                  {{ videoList.length }}
                </span>
              </div>
              <!-- 进度条 -->
              <div class="bar margin-top-sm"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗播放视频 -->
    <el-drawer
      :title="cenTitle"
      :visible.sync="drawer"
      direction="btt"
      size="100%"
    >
      <video
        id="popVideo"
        :preload="preload"
        :poster="videoImg"
        align="center"
        controls="true"
        :autoplay="autoplay"
        style="object-fit: fill"
        class="video-code"
      >
        <source :src="videoSrc" type="video/mp4" />
      </video>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "tapVideo",
  props: ["videoList"],
  data() {
    return {
      // 大屏视频
      videoSrc: "",
      videoImg: "",
      //  width: "1920", // 设置视频播放器的显示宽度（以像素为单位）
      //  height: "800", // 设置视频播放器的显示高度（以像素为单位）
      preload: "auto", //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      controls: false, // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      autoplay: "muted", // 自动播放属性,muted:静音播放
      //居中标题
      cenTitle: "",
      //右下角 视频选择 显示
      ifVideo: false,
      //显示那个视频
      videoId: 0,
      //视频下标
      indexId: 0,
      //弹窗播放视频
      drawer: false,
    };
  },
  created() {
    this.videoInit();
  },
  methods: {
    videoInit() {
      // console.log(this.videoList);
      // 播放视频
      this.videoSrc = this.$api + this.videoList[this.videoId].file;
      //视频背景
      this.videoImg = this.$api + this.videoList[this.videoId].image;
      //视频标题
      this.cenTitle = this.videoList[this.videoId].name;
    },
    //移入
    mouseOver(item, index) {
      // console.log("鼠标移入", index);
      //显示视频
      this.ifVideo = true;
      //显示那个视频
      this.videoId = index;
    },
    //移除
    mouseLeave() {
      // console.log("鼠标移除");
      //隐藏视频
      this.ifVideo = false;
    },
    //选中视频-
    slectVideo(item, index) {
      // console.log(item);
      //视频下标
      this.indexId = index;
      //标题
      this.cenTitle = item.name;
      //动态修改视频
      this.videoSrc = this.$api + item.file;
      let vdo = document.getElementById("playVideos");
      vdo.src = this.videoSrc;
      vdo.play();
    },
    //播放视频弹窗
    popV() {
      // console.log("打开弹窗");
      //动态修改视频
      // let vd = document.getElementById("popVideo");
      // vd.src = this.videoSrc;
      // vd.play();
      //打开弹窗
      this.drawer = true;
    },
  },
};
</script>

<style lang="scss" scoped>
//全屏视频
.video-code {
  position: relative;
  height: 100%;
  width: 100vw;
  // height: 900px;
  // width: 1920px;
  margin-top: 4px;
  // object-fit: fill;
}

//视频 标题 居中显示
.center-bot {
  position: absolute;
  top: 460px;
  width: 100vw;
}
//鼠标移动到 观看影片
.showCss:hover {
  color: #ffff;
}

// 右下角 视频区域
.right-bot {
  position: absolute;
  bottom: 40px;
  right: 20px;
  height: 280px;
  // z-index: 11;
}

// 右下角 视频选择
.right-video {
  width: 190px;
  height: 190px;
}
.bot-lebo {
  position: relative;
  width: 200px;
  height: 100%;
  margin-left: 20px;
  //   background-color: aqua;
  //   width: 190px;
  //   height: 190px;
  .bot-bottom {
    position: absolute;
    bottom: 0px;
    left: 0px;
  }
  //进度条
  .bar {
    width: 200px;
    height: 2px;
    background-color: red;
  }
}
</style>
